
const digest = '5b65d9a1563a8c123dbbbd42ff2e0205ea6974bb8af2710fbe189bb72affe44c';
const classes = {"wrapper":"_wrapper_6d646_1"};
const css = `._wrapper_6d646_1 {
  display: flex;
  flex-direction: column;
  margin: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  